module.exports = __webpack_public_path__ + "static/img/lvdaizi.13c94cfd.jpg";